import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px;
`;

export const ContainerHeader = styled.div`
  padding: 10px;
  gap: 10px;

  display: flex;
  flex-direction: column;
`;

